export const googleAuthButtonI18NDe = {
    withGoogle: "mit Google",
};
